import { Mesh, Node, PhongMaterial, VBOGeometry, Viewer } from '@xeokit/xeokit-sdk';
import { math } from '@xeokit/xeokit-sdk/dist/xeokit-sdk.es.js';

export class HitHelper {
  private quat = new Float32Array(4);
  private zeroVec = new Float32Array([0, 0, -1]);
  private direction = new Float32Array(3);
  private node: Node | null = null;
  private viewer: Viewer;

  constructor(viewer: Viewer) {
    this.viewer = viewer;
  }

  addMesh() {
    if (!this.viewer || this.node) return;

    this.node = new Node(this.viewer.scene, {
      pickable: false,
      visible: true,
      position: [0, 0, 0],
      children: [
        new Mesh(this.viewer.scene, {
          geometry: new VBOGeometry(this.viewer.scene, {
            primitive: 'triangles',
            positions: [-0.5, 0.5, -0.02, 0.5, 0.5, -0.02, -0.5, -0.5, -0.02, 0.5, -0.5, -0.02],
            indices: [0, 1, 2, 2, 1, 3],
          }),
          material: new PhongMaterial(this.viewer.scene, {
            emissive: [0.26, 0.2, 0.66],
            diffuse: [0.26, 0.2, 0.66],
            alpha: 0.7,
          }),
          pickable: false,
          clippable: false,
        }),
      ],
      colorize: [0, 1, 0],
      opacity: 1,
    });
  }

  removeMesh() {
    if (!this.node) return;

    for (const child of this.node.children) {
      child.destroy();
    }

    this.node.destroy();
    this.node = null;
  }

  setRootNodeScale = (size: number) => {
    if (!this.node) return;
    this.node.scale = [size, size, size];
  };

  show(hit: { worldPos: number[]; worldNormal?: number[] }) {
    this.addMesh();

    if (!this.node) return;

    this.node.position = hit.worldPos;
    //this.node.visible = true;
    this.direction.set(hit.worldNormal || [0, 0, 1]);
    math.vec3PairToQuaternion(this.zeroVec, this.direction, this.quat);
    //@ts-ignore
    this.node.quaternion = this.quat;
  }
  hide() {
    this.removeMesh();
    //this.node.visible = false;
  }
}
